// MODEL : instance of FieldFilter
//
define('app/filters/controls/HasFilterControl',['require','app/visualizations/FormatFactory','./InFilterControl','glu/util','glu/$','hbs!./HasFilterControl.hbs'],function(require) {
	'use strict';

	var
		FormatFactory = require('app/visualizations/FormatFactory'),
		InFilterControl = require('./InFilterControl'),
		_ = require('glu/util'),
		$ = require('glu/$');

	return InFilterControl.extend({
		template: require('hbs!./HasFilterControl.hbs'),

		possibleValues: function() {
			var format = FormatFactory.formatterForType(this.model.type(), {
				enumeration: this.model.enumeration(),
				displayFormat: this.model.getDisplayFormat()
			});

			var possibleValues = this.model.possibleValues();
			// if the field has enumeration use the enumeration as possible values
			if (!_.isEmpty(this.model.enumeration())) {
				possibleValues = _.keys(this.model.enumeration());
			}

			var self = this;
			self.vals = [];
			// reorganize possible values to a unique set
			_.each(possibleValues, function(v) {
				var otherVals = v.split(',');
				self.vals = _.union(self.vals, otherVals);
			});
			possibleValues = $.unique(self.vals);
			return _.map(possibleValues, function(v) {
				return {
					value: v,
					label: format(v)
				};
			});
		}
	});

});

